var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_vm._v("\n  NDrive Navigation Systems SA © 2017.\n  "),_c('span',{staticClass:"float-right"},[_c('span',{staticClass:"small text-muted"},[_vm._v(" "+_vm._s(_vm.$package.version))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f656408","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 294
// module chunks = 1